import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Form, Label, Input, Col, FormGroup } from 'reactstrap';
import _ from 'lodash';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import './EditDepartmentModal.css';

class EditDepartmentModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            departmentName: this.props.departmentName,
            departmentEmail: this.props.departmentEmail || ""
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen && !this.props.isOpen) {
            this.setState({
                departmentName: nextProps.departmentName,
                departmentEmail: nextProps.departmentEmail || ''
            })
        }
    }

    render() {
        return (
            <Modal className="department-modal" isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <FormGroup row>
                    <Col sm={3} className="modal-label-container">
                        <Label>{_.get(this.props.translation, 'org_staff.departments.department_name_label') + '*'}</Label>
                    </Col>
                    <Col sm={9}>
                        <Input type="text"
                               value={this.state.departmentName}
                               placeholder={`${_.get(this.props.translation, 'org_staff.departments.department_name_label')}`}
                               required
                               onChange={this.handleChange('departmentName')}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row className="email-container">
                    <Col sm={3} className="modal-label-container">
                        <Label>{_.get(this.props.translation, 'org_staff.departments.department_email_label')}</Label>
                    </Col>
                    <Col sm={9}>
                        <Input type="text"
                               value={this.state.departmentEmail}
                               placeholder={_.get(this.props.translation, 'org_staff.departments.department_email_label')}
                               onChange={this.handleChange('departmentEmail')}
                        />
                    </Col>
                </FormGroup>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn" type="submit" disabled={this.saveButtonDisabled()}>
                        {_.get(this.props.translation, sharedLabelsPath.save_changes_button)}
                    </Button>
                </div>
            </Form>
        );
    }

    saveButtonDisabled = () => {
        return this.state.departmentName === this.props.departmentName &&
            this.state.departmentEmail === this.props.departmentEmail;
    };

    handleChange = (inputName) => (e) => {
        this.setState({ [inputName]: e.target.value });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let data = {
            name: this.state.departmentName
        };

        if (!_.isNil(this.state.departmentEmail) && this.state.departmentEmail !== "") {
            data["email"] = this.state.departmentEmail;
        } else {
            data["email"] = null;
        }
        this.props.onDepartmentEdit(this.props.departmentId, data);
    }
}

EditDepartmentModal.propTypes = {
    departmentId: PropTypes.string,
    departmentName: PropTypes.string,
    departmentEmail: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onDepartmentEdit: PropTypes.func,
    onCancel: PropTypes.func
};

export default EditDepartmentModal;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/departmentModal/editDepartmentModal/EditDepartmentModal.js